module.exports = __webpack_public_path__ + "img/eight.2ca1a41d.png";